import { LoadingButton } from "@mui/lab";
import { Grid, Typography } from "@mui/material";
import React from "react";
import api from "../../services/api";
import useAuth from "../../hooks/useAuth";

function SendPhoto() {
  const { user } = useAuth();
  const keySession = "beno_photo_sent";
  const checkSession = sessionStorage.getItem(keySession);
  const [file, setFile] = React.useState<File | null>(null);
  const [loading, setLoading] = React.useState(false);
  const [sent, setSent] = React.useState(!!checkSession);

  function onChangeFile(event: React.ChangeEvent<HTMLInputElement>) {
    const selectedFile = event.target.files?.[0] || null;
    if (selectedFile) {
      setFile(selectedFile);
      event.target.value = ""; // Limpa o input após seleção
    } else {
      setFile(null);
    }
  }

  async function onSubmit() {
    if (!file) return;
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("code", `${user?.code}`);
      await api.post("/promo/send-photo", formData);
      setSent(true);
      sessionStorage.setItem(keySession, "true");
    } catch (error) {
      console.error("Erro ao enviar foto:", error);
    } finally {
      setLoading(false);
    }
  }

  if (sent) {
    return (
      <Grid
        container
        sx={{ mt: 2, maxWidth: 600, mx: "auto", textAlign: "center" }}
        spacing={1}
        alignItems="center"
        justifyContent="center"
      >
        <Grid item xs={12}>
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            Pronto! Agora é só torcer.
          </Typography>
        </Grid>
        <Typography gutterBottom>
          Sua foto foi recebida com sucesso! Agora é só torcer para ganhar.
          <br />
          Boa sorte!
        </Typography>
      </Grid>
    );
  }

  return (
    <Grid container sx={{ mt: 2, maxWidth: 600, mx: "auto" }} spacing={1}>
      <Grid item xs={12}>
        <Typography gutterBottom>
          O Dia dos Namorados está chegando e queremos celebrar o amor junto com
          você! Envie uma foto especial sua com seu par e concorra a prêmios
          incríveis em nosso sorteio exclusivo.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography fontWeight="bold" gutterBottom>
          É fácil participar:
        </Typography>
        <Typography component="ul" sx={{ fontSize: 13 }}>
          <p>Escolha uma foto que represente o seu amor.</p>
          <p>Envie para a gente através do formulário abaixo.</p>
        </Typography>
        <Grid item xs={12} sx={{ mt: 2 }}>
          <div
            style={{
              border: "1px dashed #ccc",
              padding: 16,
              borderRadius: 8,
              textAlign: "center",
            }}
          >
            {file && (
              <img
                src={URL.createObjectURL(file)}
                alt="Pré-visualização"
                style={{ maxWidth: "100%", maxHeight: 200, borderRadius: 8 }}
                onLoad={(e) =>
                  URL.revokeObjectURL((e.target as HTMLImageElement).src)
                }
              />
            )}
          </div>
        </Grid>

        <Grid
          container
          xs={12}
          justifyContent="center"
          alignItems="center"
          alignContent="center"
          justifyItems="center"
          spacing={2}
          sx={{ mt: 0.1 }}
        >
          {!!file && (
            <Grid item>
              <LoadingButton
                loading={loading}
                variant="contained"
                size="large"
                className="btn-pagar"
                sx={{
                  minWidth: 200,
                  maxWidth: 450,
                  textAlign: "center",
                }}
                onClick={onSubmit}
              >
                Enviar Foto
              </LoadingButton>
            </Grid>
          )}
          <Grid item>
            <label htmlFor="upload-photo">
              <input
                style={{ display: "none" }}
                id="upload-photo"
                name="upload-photo"
                type="file"
                accept="image/*"
                onChange={onChangeFile}
              />

              <LoadingButton
                variant="contained"
                color="warning"
                size="large"
                className="btn-pagar"
                sx={{ minWidth: 200, maxWidth: 450, textAlign: "center" }}
                onClick={() => document.getElementById("upload-photo")?.click()}
              >
                Escolher Foto
              </LoadingButton>
            </label>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="caption" sx={{ mt: 1, color: "text.secondary" }}>
            Apenas imagens
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default SendPhoto;
